import React, { useState } from 'react';
//import './Alert.css'; // נוסיף את העיצוב בהמשך

const Alert = ({ message, type, onClose }) => {
  return (
    <div className={`alert ${type}`}>
      <span>{message}</span>
      <button onClick={onClose} className="close-btn">×</button>
    </div>
  );
};

export default Alert;